var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmIconTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.96 31.0204V26.9753H18.42C18.0361 26.9753 17.656 27.0502 17.3014 27.1956C16.9468 27.3411 16.6247 27.5542 16.3535 27.8229C16.0823 28.0916 15.8673 28.4106 15.7208 28.7615C15.5744 29.1125 15.4993 29.4885 15.5 29.8682V44.6588H7V14.7907L15.5 21.9413V18.5687H24.96V14.5237L35 22.772L24.96 31.0204Z",
    fill: "#FF534A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.87 5.93409C37.87 6.70047 37.5625 7.43553 37.0151 7.9779C36.4676 8.52027 35.7249 8.82563 34.95 8.82695H15.5V5.43958L7 12.5852V0.405518H37.87V5.93409Z",
    fill: "#FF534A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 45,
    fill: "white",
    transform: "translate(7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmIconTrans);
export default __webpack_public_path__ + "static/media/farmIconTrans.86c3aa91ca54510f45f3b453f07f237f.svg";
export { ForwardRef as ReactComponent };